import { fromJS } from 'immutable'
import {
  STANDARD_PRICE_CREATE_REQUEST,
  STANDARD_PRICE_CREATE_SUCCESS,
  STANDARD_PRICE_CREATE_FAILURE,
  STANDARD_PRICE_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case STANDARD_PRICE_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case STANDARD_PRICE_CREATE_SUCCESS:
      return state
        .set('standardPriceCreate', fromJS(action.payload.createdStandardPrice))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case STANDARD_PRICE_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('standardPriceCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case STANDARD_PRICE_CREATE_RESET:
      return state
        .delete('standardPriceCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/standard-price/standard-price-create-reducer.js